// Module
var code = "<div class=\"title-parse-type clear-fix\"> <h3 class=\"card-title\">Parse properties</h3> <form> <div class=\"prop-element\"> <label>Parse type</label> <span class=\"parser select2_theme_dark\" id=\"parser\"></span> </div> </form> </div> ";
// Exports
export default code;